import TagManager from 'react-gtm-module';

export const initGTM = () => {
  TagManager.initialize({
    gtmId: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
  });
};
